
// Used buy the ran_slider shortcode to define the behavior - this one without Autoscroll

jQuery(document).ready(function(){
    jQuery(".ran-slider").slick({
        arrows: true,
        infinite: true,
        dots: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        //autoplay: autoscroll,
        //autoplaySpeed: 2000, 
    });
});